import React from 'react';
import { MobileOrTabletAndLarger } from "../../components/containers/ResponsiveComponents";
import { BrandText } from "../../components/brandText";
import { TouchableWithoutFeedback } from 'react-native-gesture-handler';
import { useNavigation } from '@react-navigation/native';


export const HeaderLogo = () => {
    const navigation = useNavigation();
    const onPress = () => {navigation.navigate('Home'); }
    return (
        <TouchableWithoutFeedback
            onPress={onPress}
            style={{ flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}
        >
            <MobileOrTabletAndLarger
                mobile={
                    // <Avatar source={poallImages.poall_logo} style={{ marginRight: 5 }} />
                    <BrandText status='primary' category='h5' style={{ textAlign: 'center' }}>pll</BrandText>
                }
                tabletAndLarger={
                    <BrandText status='primary' category='h3' style={{ textAlign: 'center' }}>poall</BrandText>
                }
            />
        </TouchableWithoutFeedback>
    );
}